export const galleryStub = {
  albums: [
    {
      id: 'club-open-2024',
      title: 'Club Open 2024',
      description: 'Höhepunkte unseres letzten großen Turniers mit Finalmomenten und Teameinläufen.',
      date: '2024-11-16',
      coverPhotoId: 'club-open-2024-01'
    },
    {
      id: 'lounge-impressions',
      title: 'KickerEck Eindrücke',
      description: 'Ein Blick in Lounge, Tische und die entspannte Atmosphäre im KickerEck.',
      date: '2024-03-12',
      coverPhotoId: 'lounge-impressions-01'
    }
  ],
  photos: [
    {
      id: 'club-open-2024-01',
      albumId: 'club-open-2024',
      fullUrl: '/img/gallery/OE.jpg',
      thumbUrl: '/img/gallery/OE-small.jpg',
      caption: 'Sieger des Club Open nach einem langen Turniertag.',
      sortOrder: 1
    },
    {
      id: 'club-open-2024-02',
      albumId: 'club-open-2024',
      fullUrl: '/img/gallery/OD.jpg',
      thumbUrl: '/img/gallery/OD-small.jpg',
      caption: 'Starke Ballwechsel am Finaltisch.',
      sortOrder: 2
    },
    {
      id: 'club-open-2024-03',
      albumId: 'club-open-2024',
      fullUrl: '/img/gallery/KickerEck.jpg',
      thumbUrl: '/img/gallery/KickerEck-small.jpg',
      caption: 'Volles Haus – alle Augen auf den Center Court.',
      sortOrder: 3
    },
    {
      id: 'lounge-impressions-01',
      albumId: 'lounge-impressions',
      fullUrl: '/img/gallery/BlickAufLounge.jpg',
      thumbUrl: '/img/gallery/BlickAufLounge-small.jpg',
      caption: 'Willkommen in der Lounge – Platz für Publikum und Pausen.',
      sortOrder: 1
    },
    {
      id: 'lounge-impressions-02',
      albumId: 'lounge-impressions',
      fullUrl: '/img/gallery/Lounge.jpg',
      thumbUrl: '/img/gallery/Lounge-small.jpg',
      caption: 'Gemütliche Sitzgelegenheiten für Spielanalysen.',
      sortOrder: 2
    },
    {
      id: 'lounge-impressions-03',
      albumId: 'lounge-impressions',
      fullUrl: '/img/gallery/Kino.jpg',
      thumbUrl: '/img/gallery/Kino-small.jpg',
      caption: 'Blick auf unsere Tribüne – nah dran am Geschehen.',
      sortOrder: 3
    }
  ]
};
